import React from 'react';
import {Atom} from '@packages/systems/wfdl';
import {px, vh} from '@packages/systems/core/utils/WebflowCssSubset';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {getChildren} from '@packages/utilities/data-utils';

const UserFormPageWrap = Atom.createRender(
  ({data, generateAttributes, attributes, classes, renderChild}) => (
    <div {...generateAttributes(attributes, classes)}>
      {getChildren(data).map((child) => renderChild(child))}
    </div>
  )
);

const config = createIntegratedAtom({
  displayName: 'Page Wrapper',
  showEmpty: true,
  style: {
    base: {
      main: {
        noPseudo: {
          height: vh(100),
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'stretch',
          maxWidth: px(340),
          marginLeft: 'auto',
          marginRight: 'auto',
        },
      },
    },
  },
  render: UserFormPageWrap,
  fields: {children: TListOfElement},
});

export default config;
